import React from "react";
import "./Garagecleanouts.css";
import { FiTrash } from "react-icons/fi";
import junk from "../../Assests/service4.webp";

const Garagecleanouts = () => {
  return (
    <section className="Garagecleanouts-section">
      <div className="Garagecleanouts-container">
        {/* Content Column */}
        <div className="Garagecleanouts-content">
          <div className="content-header">
            <div className="service-icons">
              <FiTrash size={32} />
            </div>
            <h1 className="service-title">
              <span className="title-accent">Garage</span> Cleanouts
            </h1>
          </div>

          <p className="service-description">
            Clearing out a garage can feel overwhelming—our cleanout service makes it simple.
            Whether you’re reclaiming space, moving, or tackling years of accumulated clutter,
            our crew takes care of the heavy lifting, hauling, and disposal so you don’t have to.
            We handle everything from furniture and appliances to tools, boxes, and general junk,
            leaving your garage neat, organized, and ready to use again.
          </p>

          <p className="service-description">
            Usable items are donated, recyclable materials are sorted, and the rest is disposed of
            responsibly. Our team works quickly and efficiently, minimizing disruption while making
            the process stress-free from start to finish. No matter how packed or messy the garage,
            we’re equipped to clear it out completely—so you can enjoy a clean, safe, and functional
            space once more.
          </p>

          <div className="cta-group">
            <a
              href="https://app.squareup.com/appointments/book/41vplmwf0luh01/LTHMTFD90TMRT/start"
              className="primary-cta"
              target="_blank"
              rel="noopener noreferrer"
            >
              Schedule Your Pickup
              <span className="cta-arrow">→</span>
            </a>
          </div>
        </div>

        {/* Image Column */}
        <div className="Garagecleanouts-image">
          <img
            src={junk}
            alt="Professional team performing a garage cleanout"
            className="main-image"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default Garagecleanouts;
